require('./stylesheet/style.scss');

angular.module('warning.notification', [])
	.directive('warningNotification', [function() {
		return {
			template: require('./templates/index.html'),
			link: function($scope) {
				$scope.isWithinTimeRange = function() {
					var now = new Date();
					var start = new Date('2023-03-25T00:00:00+02:00');
					var end = new Date('2023-03-25T06:00:00+02:00');
					return (now >= start && now <= end);
				};
			}
		}
	}

	]);

module.exports = 'warning.notification';



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/warning-notification/index.js
 ** module id = 252
 ** module chunks = 1
 **/